import { Row } from "react-bootstrap";
import ContentLoader from "react-content-loader";
import ReportSearchFilter from "./report-search-filter";
import SecStackReportList from "./msp-report-list";

const SecurityStackReportLoader = (props) => {
  return (
    <Row style={{ paddingTop: "2%" }}>
      <ContentLoader
        speed={2}
        width={'100%'}
        height={750}
        backgroundColor="#F6F8FB"
        foregroundColor="#ecebeb"
        {...props}
      >
        <rect x="2%" y="25" rx="12" ry="12" width="96%" height="50" />
        <rect x="2%" y="80" rx="12" ry="12" width="96%" height="50" />
        <rect x="2%" y="135" rx="12" ry="12" width="96%" height="50" />
        <rect x="2%" y="190" rx="12" ry="12" width="96%" height="50" />
        <rect x="2%" y="245" rx="12" ry="12" width="96%" height="50" />
        <rect x="2%" y="300" rx="12" ry="12" width="96%" height="50" />
        <rect x="2%" y="355" rx="12" ry="12" width="96%" height="50" />
        <rect x="2%" y="410" rx="12" ry="12" width="96%" height="50" />
        <rect x="2%" y="465" rx="12" ry="12" width="96%" height="50" />
        <rect x="2%" y="520" rx="12" ry="12" width="96%" height="50" />
        <rect x="2%" y="575" rx="12" ry="12" width="96%" height="50" />
        <rect x="2%" y="630" rx="12" ry="12" width="96%" height="50" />
        <rect x="2%" y="685" rx="12" ry="12" width="96%" height="50" />
      </ContentLoader>
    </Row>
  );
};

const ReportListSection = ({
  searchString,
  setSearchInput,
  handleInputChange,
  SearchInput,
  sortOrder,
  setSortOrder,
  getMSPReportsList,
  onReportClick,
  loading,
  pageData,
  onReportViewClick,
  removeReportFromList
}) => {
  return (
    <>
      <div className="d-flex align-items-center justify-content-between" style={{ margin: '0 24px' }}>
        <div>
          <span className="f-16 line-height-24 f-600 f-black">0 Reports</span>
        </div>
        <div className="d-flex align-items-center justify-content-end" >
          <img
            src="/images/actioncenter/folder.svg"
            alt=""
            className="mr-2"
          />
          <ReportSearchFilter
            searchValue={searchString}
            searchOnChange={(e) => {
              setSearchInput(true);
              handleInputChange(e);
            }}
            searchOnCross={() => {
              handleInputChange({ target: { value: "" } });
            }}
            searchInputRef={SearchInput}
            onSortClick={() => {
              let updatedSortOrder = sortOrder === 1 ? 0 : 1;
              getMSPReportsList({ passedSortOrder: updatedSortOrder })
              setSortOrder(updatedSortOrder)
            }}
            onReportClick={onReportClick}
          />
        </div>
      </div>
      {
        loading ? <SecurityStackReportLoader /> : <SecStackReportList
          list={pageData?.SecurityStackReport_List}
          onReportAdd={() => { onReportClick(); }}
          onReportViewClick={(id, reportId) => { onReportViewClick(id, reportId); }}
          searchValue={searchString}
          removeReportFromList={removeReportFromList}
        />
      }
    </>
  );
};

export default ReportListSection;

